import React from 'react';

export default class SiteRow extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this)
  }

  openModal() {
    const {RowData, setDataEdit} = this.props;
    setDataEdit(RowData)
  }

  render() {
    const {RowData} = this.props
    return (
      <tr>
        <td>
          {RowData.Name}
        </td>
        <td>
          {RowData.Type.Name}
        </td>
        <td>
          {RowData.City.Name}
        </td>
        <td>
          {RowData.ProjectName}
        </td>
        <td>
          {RowData.Status.Name}
        </td>
        <td className="text-center">
          <button className="btn btn-4r btn-sm btn-primary" onClick={()=>this.openModal('modal_update')}><i className="icon-pencil"></i></button>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/location/site/helper/component/SiteRow.js